import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {
    assetsDialogsSelector,
    cleanSaas,
    hideExportCsv,
    loadings,
    minMaxLoadedPage,
    openExportCsv,
    openReleaseDialog,
    pageInfoSelector,
    replaceMinMaxLoadedPage,
    saasAssetsSelector,
    saasAssetsSettingsSelector,
    selectSaasAsset,
    setImportCsvDialogAction,
} from "../../store/store";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {TSaasAsset} from "../../types";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_SAAS,
    PATH_LOCAL_ASSET_MANAGEMENT_SAAS_ID,
    PATH_LOCAL_ASSET_MANAGEMENT_SAAS_NEW,
    PATH_LOCAL_ASSET_MANAGEMENT_SAAS_SETTINGS,
} from "../../constants";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import React, {useEffect, useState} from "react";
import {
    exportCsvSaasAssetsAction,
    getSaasAssetsAction,
    getSaasAssetsSettingsAction,
    GetSaasAvailableFieldsForExport,
} from "../../store/actions";
import {CommonFilterType, minMaxLoadedPageType} from "../../../../../newShared/components/genericTable/types";


export const useSaasAssetsList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {isLoadingList, isLoadingSettings, isLoadingExport, isLoadingFields} = useSelector(loadings);
    const saasAssets = useSelector(saasAssetsSelector);
    const _pageInfo = useSelector(pageInfoSelector);
    const dialogs = useSelector(assetsDialogsSelector);


    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            // title: tMenu('SaaS'),
            title: 'SaaS',
            path: PATH_LOCAL_ASSET_MANAGEMENT_SAAS
        },
    ]);

    // const controller = new AbortController();

    //search and filters
    // const [filter, setFilter] = useState<TCommonAssetsFilter>({
    //     nameLike: '',
    //     prevSearch: '',
    // })

    // const getAssets = (page: number, count: number, _filter: TCommonAssetsFilter, enterDown: boolean) => {
    //     !isLoadingList && dispatch(getSaasAssetsAction({data: {
    //             page,
    //             count,
    //             filters: {
    //                 nameLike: enterDown && _filter.nameLike ?  [_filter.nameLike] : (!enterDown && _filter.prevSearch ? [_filter.prevSearch] : []),
    //                 // type: (_filter.type && _filter.type !== 'Any') ? [_filter.type] : [],
    //             }}, signal: controller.signal}))
    //     !isLoadingList && setFilter({..._filter, prevSearch: enterDown && _filter.nameLike ? _filter.nameLike  : (!enterDown && _filter.prevSearch ? _filter.prevSearch : '')})
    // }

    const getSettings = (signal?: AbortSignal) => {dispatch(getSaasAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal}))}

    // const clean = () => dispatch(cleanUp);

    const goToAsset = (asset: TSaasAsset) => {
        if(asset) {
            dispatch(selectSaasAsset(asset));
            history.push(`${PATH_LOCAL_ASSET_MANAGEMENT_SAAS_ID.replace(':id', asset.id)}`);
        }
    }

    useEffect(() => {
        !isLoadingList && getSettings();

        // return () => {
            // controller.abort();
            // clean();
        // }
        //eslint-disable-next-line
    }, []);

    const goToAddAsset = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_SAAS_NEW);
    const goToSettings = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_SAAS_SETTINGS);


    //MENU
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // const exportCsv = () => {
    //     handleClose();
    //     dispatch(exportCsvSaasAssetsAction())
    // };
    const handleOpenExportCsv = () => {
        dispatch(openExportCsv());
        dispatch(GetSaasAvailableFieldsForExport());
    }

    const handleCloseExportCsv = () => {
        dispatch(hideExportCsv());
    }

    const handleExportCsv = (fieldKeys: string[]) => {
        handleClose();
        dispatch(exportCsvSaasAssetsAction({fieldKeys, isDownload: _pageInfo.total < 10000}))
    };

    const handleImportCSV = () => {
        handleClose();
        dispatch(setImportCsvDialogAction({isOpen: true}));
    }

    //filters
    // const setSearch = (search: string) => setFilter({...filter, nameLike: search});
    //
    // const handleCleanSearch = () => {
    //     const newFilter = {...filter, nameLike: '', prevSearch: ''};
    //     setFilter(newFilter);
    //     getAssets(0, DEFAULT_COUNT, newFilter, false);
    // }
    //
    // const handleEnterKey = (e: any) => {
    //     if(e.keyCode === 13){
    //         getAssets(0, DEFAULT_COUNT, filter, true);
    //     }
    // }

    const handleOpenRelease = () => {
        dispatch(openReleaseDialog({assetType: 'saas'}));
        handleClose();
    }

    // pagination
    // const {bottomLoader, onScroll, scrollRef} = useScrollPagination({
    //     getData: ({page, count}) => {
    //         getAssets(
    //             page, count, filter,false
    //         )
    //     },
    //     arrayLength: saasAssets.length,
    //     isLoading: isLoadingList,
    //     pageInfo: _pageInfo,
    //     cleanData: () => {},
    //
    // })

    const {minLoadedPage, maxLoadedPage} = useSelector(minMaxLoadedPage);

    return {
        settings: useSelector(saasAssetsSettingsSelector),
        // setSearch,
        // hasMore: _pageInfo.total > ((_pageInfo.page + 1) * _pageInfo.count),
        saasAssets,
        goToAsset,
        goToAddAsset,
        goToSettings,
        handleImportCSV,
        handleOpenExportCsv,
        handleOpenRelease,

        menu: {
            anchorEl,
            handleClose,
            handleClick,
            open,
        },

        // filter: {
        //     filter,
        //     setFilter,
        //     setSearch,
        //     handleEnterKey,
        //     handleCleanSearch,
        // },

        exportCsv: {
            isOpen: dialogs.exportCsv.isOpen,
            availableFields: dialogs.exportCsv.fields,
            handleExportCsv,
            handleClose: handleCloseExportCsv,
        },

        isLoadingList,
        isLoadingFields,
        // isShowingNoAssets: !isLoadingList && saasAssets.length === 0 && !filter.prevSearch && !filter.type?.length && !filter.nameLike.length,
        isLoadingSettings,
        isLoadingExport,

        // pagination: {
        //     bottomLoader: bottomLoader && saasAssets.length < _pageInfo.total,
        //     onScroll,
        //     scrollRef
        // },
        genericTable: {
            paging: {
                pageInfo: _pageInfo,
                isLoading: isLoadingList,
                minLoadedPage,
                maxLoadedPage,
                setMinMaxLoadedPage: (data: minMaxLoadedPageType) => dispatch(replaceMinMaxLoadedPage(data)),
                clearRows: () => dispatch(cleanSaas()),
                fetchPaging: (page: number, count: number, filters: CommonFilterType, search: string) => {
                    dispatch(getSaasAssetsAction({data: {page, count, filters}}));
                },
            },
        }
    }
}
